// extracted by mini-css-extract-plugin
module.exports = {"close":"toast-body_close__1c5LW","body":"toast-body_body__1DAQk","grow":"toast-body_grow__19nY9","message":"toast-body_message__fq8QM"};